import Link from 'next/link';
import React from 'react';
import type { ReactNode } from 'react';

import { PAGE_BLOG } from '@root/constants/routes';
import LogoIcon from 'components/Logo';

type Props = {
  className?: string;
  children: ReactNode;
};

const LayoutBlog = ({ className, children }: Props): JSX.Element => (
  <div className={className ? className : ''}>
    <div className="container mb-48 pt-80">
      <Link href={PAGE_BLOG} as={PAGE_BLOG} className="flex items-center gap-16">
        <LogoIcon />
        <div className="text-h1 border-l-1 border-black pl-16 uppercase">Blog</div>
      </Link>
    </div>

    {children}
  </div>
);

export default LayoutBlog;
